import { getConceptCodes } from "@intocare/datatypes/lib/code-system";
import { composeValueSet } from "@intocare/datatypes/lib/value-set";

import { OBSERVATION_LOCATION } from "../../code-system/observation-location";

export const OBSERVATION_LOCATION_DISPLAY = composeValueSet({
	name: "OBSERVATION_LOCATION_DISPLAY",
	description: "Current selection of locations for displaying observations.",
	system: OBSERVATION_LOCATION,
	include: getConceptCodes(OBSERVATION_LOCATION),
});
